import { estiloPrioridade } from "services/Utils"

export default function Prioridade({ prioridade, concluida }) {
  return (
    <span style={{ ...estiloPrioridade(prioridade, concluida), borderRadius: 3, padding: '3px 7px' }}>{prioridade || 'Sem prioridade'}</span>
  )
}